import React, { useState } from 'react'

import { BaseDialog, Stepper } from 'shared'
import { withModal } from 'utils/providers/ModalProvider'
import modals from 'constants/modals'
import { BaseModalComponentType } from '../types'
import EnterEmailStep from './EnterEmailStep'
import VerifyCodeStep from './VerifyCodeStep'

const EditEmailModal = ({ isOpen, closeModal }: BaseModalComponentType) => {
  const [newEmail, setNewEmail] = useState('')

  return (
    <BaseDialog
      open={isOpen}
      onClose={closeModal}
      title={newEmail ? 'Verify email' : 'Change email'}
    >
      <Stepper>
        <EnterEmailStep
          onEmailSubmitted={setNewEmail}
          closeModal={closeModal}
        />
        <VerifyCodeStep newEmail={newEmail} closeModal={closeModal} />
      </Stepper>
    </BaseDialog>
  )
}

export default withModal(modals.editEmail)(EditEmailModal)
